import {useQuery} from "@tanstack/react-query";

import {getMaterialQueryOptions} from "./get-material.query-options";

export function useGetMaterial(id: string, includeDeleted = false) {
  return useQuery(getMaterialQueryOptions(id, includeDeleted));
}
